<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0 mt-4">
                <v-autocomplete
                        v-model="finalFolder"
                        dense
                        :items="folders"
                        outlined
                        item-text="name"
                        item-value="fid"
                        return-object
                        small-chips
                        deletable-chips
                        label="Target Folder">
                </v-autocomplete>
            </v-card-actions>
            <v-card-actions class="mt-n5">
                <v-spacer></v-spacer>
                <v-btn :loading="loading"
                        class="ma-2"
                       color="primary"
                       @click="onPressMove">MOVE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";

export default {
    name: "popup-move-snapshot-to-folder",
    props: {},
    components: {},
    data: () => ({
        dialog: false,
        snapshot: null,
        finalFolder: null,
        loading: false,
    }),
    computed: {
        folders(){
            let folders = UsersBackendUtils.getFolders();
            let final = []
            for (let i in folders){
                if (this.snapshot != null && !folders[i].snapshots.includes(this.snapshot.id)){
                    final.push(folders[i]);
                }
            }
            return final;
        }
    },
    methods: {
        show(snapshot) {
            this.dialog = true
            this.snapshot = snapshot
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        onPressMove() {
            if (this.finalFolder == null){
                this.$notify({title: 'Please select target folder!', type: "error"});
                return;
            }
            let initFolder = null;
            let folders = UsersBackendUtils.getFolders();
            for (let i in folders){
                let folder = folders[i];
                if (folder.snapshots.includes(this.snapshot.id)){
                    initFolder = folder
                }
            }
            //console.log(initFolder == null ? "" : initFolder.fid, this.finalFolder.fid, this.snapshot.id)
            let data = {to_folder_id: this.finalFolder.fid, snapshotId:[this.snapshot.id]}
            if (initFolder != null){ data["from_folder_id"] = initFolder.fid; }
            this.loading = true;
            UsersBackendUtils.moveSnapshotToFolder(data).then(() => {
                this.$notify({title: 'Snapshot successfully moved!', type: "success"});
                this.loading = false;
                this.hide()
            }).catch((error) => {
                //console.log(error)
                this.$notify({title: 'Snapshot move failed!', text: error, type: "error"});
                this.loading = false;
                this.hide()
            })
        },
    },
}
</script>

<style scoped>

</style>